import type {CanvasImage} from './canvas-types';
export interface CreativeExportSnapshot {projectId:number;imageId:string;doc:unknown;stage:unknown}
export function assertCreativeExportSnapshot(snapshot:CreativeExportSnapshot,current:{projectId:number|null;imageId:string|null;doc:unknown;stage:unknown}):void {
 if(snapshot.projectId!==current.projectId || snapshot.imageId!==current.imageId || snapshot.doc!==current.doc || snapshot.stage!==current.stage)
  throw new Error('The image or edit changed while saving. Select it and save again.');
}
interface ExportCanvas {
 addImageNextTo:(src:string,width:number,height:number,filename:string,sourceId:string,originalWidth?:number,originalHeight?:number,prompt?:string,projectIdOverride?:number)=>void;
 _writeImages:(projectId:number,update:(images:CanvasImage[])=>CanvasImage[])=>void;
}
export function deliverCreativeExport(canvas:ExportCanvas,origin:{projectId:number;imageId:string;sourceUrl:string;width:number;height:number;tileW?:number;tileH?:number},url:string):'copy'|'updated' {
 if(origin.sourceUrl.includes('/creative-edit/exports/')){
  canvas._writeImages(origin.projectId,images=>{
   const source=images.find(image=>image.id===origin.imageId);
   if(!source || source.src!==origin.sourceUrl)throw new Error('The source image changed while saving. Save again.');
   return images.map(image=>image.id===origin.imageId?{...image,src:url}:image);
  });
  return 'updated';
 }
 canvas.addImageNextTo(url,origin.tileW??origin.width,origin.tileH??origin.height,`edited-${Date.now()}.png`,origin.imageId,origin.width,origin.height,undefined,origin.projectId);
 return 'copy';
}
